module.exports = __webpack_public_path__ + "245521a122e7f1da0ddc8541214b305b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/5_E2.mp3
// module id = 80
// module chunks = 0